var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Icon as UIIcon, CountryList } from "../UI";

function getFaSize(size) {
  switch (size) {
    case 'xs':
      return 'sm';
    case 'sm':
      return 'lg';
    case 'md':
      return '2x';
    case 'lg':
      return '2x';
    case 'xlg':
      return '2x';
    default:
      return 'sm';
  }
}

export class Icon extends Component {
  getJSData() {
    const { data } = this.props;
    let _data = data;

    if (data && _data.toJS) {
      _data = _data.toJS();
    }

    return _data;
  }

  getIcon(_data) {
    const { className, size } = this.props;
    let icon;

    if (_data.type === 'Icons') {
      icon = /*#__PURE__*/_jsx(UIIcon, { icon: `${_data._id}`, size: `${getFaSize(size)}` });
    }

    if (_data.type === 'Flags') {
      const flagClassName = `fi fi-${CountryList.get(_data._id).cca2}`.toLowerCase();
      const componentClassName = `${className} ${flagClassName}`;
      icon = /*#__PURE__*/_jsx("span", { className: componentClassName });
    }

    return icon;
  }

  render() {
    const { className } = this.props;
    let html = null;
    const _data = this.getJSData();

    if (_data && _data._id) {
      const icon = this.getIcon(_data);
      html = /*#__PURE__*/_jsx("span", { className: className }, void 0, icon);
    }

    return html;
  }
}

Icon.defaultProps = {
  data: undefined,
  className: undefined,
  size: undefined
};







export default connect()(Icon);